import React, { useState } from 'react'
import { FaThumbsUp, FaComment, FaEllipsisV, FaRegThumbsUp, FaSave, FaTrash, FaFlag, FaPen, FaShare, FaTimes, FaMinusCircle, FaEnvelope, FaMarker, FaEllipsisH } from 'react-icons/fa'
import officeImg from "../assets/office.png"
import UserImage from "../assets/user.png"
import moment from 'moment'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { api, apiJson } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import Linkify from 'linkify-react'

const ModeratePostCard = ({ orgPost }) => {
    const [approving, setApproving] = useState(false)
    const [deleting, setDeleting] = useState(false)

    // console.log(orgPost)


    const userId = useSelector((state) => state.auth?.user?.user?._id)

    const { organization } = useParams()
    const navigate = useNavigate()

    const imageFiles = orgPost?.files?.filter(f => f.type === "image") || [];
    const [focusedImg, setFocusedImg] = useState(imageFiles[0]?.url || null);

    const linkifyOptions = {
        target: "_blank",
        rel: "noopener noreferrer",
        className: "post-link"
    };


    const renderImages = () => (
        <>
            <div className="focused-image">
                <img src={focusedImg} alt="onnize" />
            </div>

            {imageFiles.length > 1 && (
                <div className="image-selector">
                    {imageFiles.map((file, i) => (
                        <div
                            key={i}
                            className="image-selector-wrapper"
                            onClick={() => setFocusedImg(file.url)}
                        >
                            <img src={file.url} alt={file.name} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );

    const renderVideo = (file) => (
        <div className="video-container">
            <video controls>
                <source src={file.url} type={file.mimeType} />
            </video>
        </div>
    );

    const renderDocuments = () => (
        <div className="document-container">
            {orgPost.files.map((file, i) => {
                const ext = file.name.split(".").pop().toLowerCase();

                if (ext === "pdf") {
                    return (
                        <div key={i} className="document-preview">
                            <iframe src={file.url} title={file.name} loading="lazy" />
                            <a
                                href={file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="doc-action"
                            >
                                Open PDF
                            </a>
                        </div>
                    );
                }

                return (
                    <div key={i} className="document-download">
                        <span className="doc-name">{file.name}</span>
                        <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="doc-action"
                        >
                            Download
                        </a>
                    </div>
                );
            })}
        </div>
    );

    const renderFiles = () => {
        if (!orgPost.files?.length) return null;

        switch (orgPost.files[0].type) {
            case "image":
                return renderImages();
            case "video":
                return renderVideo(orgPost.files[0]);
            case "document":
                return renderDocuments();
            default:
                return null;
        }
    };

    const deletePost = async () => {
        const confirmed = window.confirm("Delete this post?");
        if (!confirmed) return;

        try {
            setDeleting(true);

            const res = await api.delete(`/${orgPost.organization.name}/manage/moderate/${orgPost._id}`);
            toast.success(res.data.message)
        } catch (err) {
            console.error(err);
            alert("Something went wrong deleting post");
        } finally {
            setDeleting(false);
        }
    };
    const approvePost = async () => {

        try {
            setApproving(true)
            const res = await api.patch(`/${orgPost.organization.name}/manage/moderate/${orgPost._id}`);
            toast.success(res.data.message)
        } catch (err) {
            console.error(err);
            alert("Something went wrong,post not approved");
        } finally {
            setApproving(false);
        }
    };

    return (
        <div className='post'>
            <div className='org-post'>
                <div className="org-post-header">
                    <div className="org-post-org-info">
                        <div className="profile-details">
                            <img
                                src={
                                    orgPost.organization?.logo?.current
                                        ? orgPost.organization.logo.current.url
                                        : officeImg
                                } alt="user profile"
                                className="orgPost-profile-img"
                            />
                            <div className="post-data-details">
                                <p
                                    className="post-profile-name">{orgPost?.organization?.name}
                                </p>
                                <div className="post-dates">
                                    <p>{moment(orgPost.createdAt).fromNow()}</p>
                                    <p className='post-audience'>{orgPost.audience}</p>
                                    <p className='post-label'>{orgPost.postLabel}</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <Link to={`/user/${orgPost.createdBy._id}`}>
                        <div className="org-post-user">
                            <div className="org-post-userimg">
                                <img src={orgPost.createdBy?.avatar ? orgPost.createdBy.avatar.url : UserImage} alt='' />
                            </div>
                            <div className="org-post-username">
                                <h3 className=''>{orgPost.createdBy?.firstname} {orgPost.createdBy?.lastname}</h3>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="post-body">
                {
                    orgPost.postText &&
                    <Linkify options={linkifyOptions}>
                        <div className="text" onClick={() => navigate(`/${organization}/posts/${orgPost._id}`, { state: { post: orgPost } })}
                        >
                            <p>{orgPost.postText.substring(0, 100)}</p>
                        </div>
                    </Linkify>
                }

                {orgPost.filesUrls?.length > 0 &&
                    <div className="postcard-images">
                        {renderFiles()}
                    </div>
                }
            </div>
            <div className="post-footer">
                <div className="post-moderation-footer-icon"
                    onClick={deletePost}
                >
                    <FaTrash />
                    <p>{deleting?"...":"Delete"}</p>
                </div>
                <div className="post-moderation-footer-icon"
                    onClick={approvePost}
                >
                    <FaThumbsUp />
                    <p>{approving?"...":"Approve"}</p>
                </div>
            </div>
        </div>
    )
}

export default ModeratePostCard